// Strings for merging stock items (kitchen flow, go-live): "Merge into…" on
// an item, and "Upload merge answers" for the client's brand-merge review.
export const MG = {
  menu: 'Merge into…',
  title: (name: string) => `Merge “${name}” into another item`,
  help: 'Use this when two items are really the same thing (brands that are interchangeable). Its stock, barcodes, prices, recipes and open orders move to the item you pick; this one is archived. Its history stays.',
  search: 'Search the item to keep…',
  noMatch: 'No items match.',
  change: 'Change item',
  keepLabel: 'Keep',
  mergeLabel: 'Merge in',
  factorQuestion: (from: string, to: string) => `How many ${to} is one ${from}?`,
  factorHelp: 'These units cannot be converted automatically. Type the amount, or keep the items apart.',
  checking: 'Working out what will move…',
  previewTitle: 'What will happen',
  stockLine: (from: string, to: string, place: string) => (place ? `${place}: ${from} → ${to}` : `${from} → ${to}`),
  nothingInStock: 'No stock to move.',
  onHandAfter: (qty: string) => `The kept item will hold ${qty}.`,
  conversion: (from: string, to: string, factor: string) => `1 ${from} = ${factor} ${to}`,
  confirm: 'Merge',
  merging: 'Merging…',
  cancel: 'Cancel',
  done: (merged: string, kept: string) => `${merged} merged into ${kept}`,
  note: 'Note (optional)',
  /** what else moved: [one, many] */
  moved: {
    lots: ['lot', 'lots'],
    barcodes: ['barcode', 'barcodes'],
    price_history: ['price record', 'price records'],
    vendor_items: ['vendor catalogue row', 'vendor catalogue rows'],
    menu_recipes: ['menu recipe line', 'menu recipe lines'],
    modifier_recipes: ['add-on recipe line', 'add-on recipe lines'],
    prep_recipes: ['prep recipe line', 'prep recipe lines'],
    tracked_products: ['linked menu item', 'linked menu items'],
    par_levels: ['stock level', 'stock levels'],
    request_lines: ['open request line', 'open request lines'],
    po_lines: ['open purchase-order line', 'open purchase-order lines'],
    plan_rows: ['kitchen plan row', 'kitchen plan rows'],
    plan_extras: ['packaging / extras row', 'packaging / extras rows'],
  } as Record<string, readonly [string, string]>,
  bulk: {
    button: 'Upload merge answers',
    title: 'Brand-merge answers',
    help: 'Upload brand_merge_review.csv as the client sent it back (Y / N per item). We check it first and show what will happen; nothing changes until you press Apply.',
    choose: 'Choose the file (.csv)',
    checking: 'Checking…',
    summary: (merge: number, items: number) => `${merge} group${merge === 1 ? '' : 's'} to merge (${items} item${items === 1 ? '' : 's'} folded in)`,
    summaryDone: (merge: number, items: number) => `${merge} group${merge === 1 ? '' : 's'} merged (${items} item${items === 1 ? '' : 's'} folded in)`,
    others: (refused: number, skipped: number, already: number, unanswered: number) =>
      [refused ? `${refused} refused` : '', skipped ? `${skipped} skipped` : '', already ? `${already} already merged` : '', unanswered ? `${unanswered} rows not answered` : '']
        .filter(Boolean).join(' · '),
    colGroup: 'Group',
    colKeep: 'Kept as',
    colMerged: 'Folded in',
    colResult: 'Result',
    status: {
      merge: 'Will merge',
      merged: 'Merged',
      already_merged: 'Already merged',
      skipped: 'Skipped',
      refused: 'Not merged',
    },
    chosenBy: {
      client_note: 'the client said keep',
      client_named: 'named by the client',
      most_bought: 'most bought',
    },
    renamed: (name: string) => `renamed “${name}”`,
    apply: (n: number) => `Apply ${n} merge${n === 1 ? '' : 's'}`,
    applying: 'Merging…',
    nothingToApply: 'Nothing to merge in this file.',
  },
} as const
